import { ADMIN_JWT_COOKIE_NAME } from './adminAuth';
import { deleteCookie, setCookie } from './cookies';
import { deleteImpersonationCookie, setImpersonationCookie, } from './impersonation';
export const IMPERSONATE_ID_PARAM_NAME = 'impersonateId';
export const ADMIN_TOKEN_PARAM_NAME = 'adminToken';
export const REDIRECT_URL_PARAM_NAME = 'redirectUrl';
/**
 * Narrows an untrusted redirect target to a path on this site, so a crafted
 * `?redirect=` can't turn a login or impersonation hand-off into an open
 * redirect. Anything suspect collapses to the site root.
 */
export function getSafeRedirectPath(input) {
    if (!input)
        return '/';
    if (!input.startsWith('/'))
        return '/';
    // `//evil.com` is protocol-relative, and browsers normalise the backslash in
    // `/\evil.com` to the same thing — both resolve to a different origin.
    if (input[1] === '/' || input[1] === '\\')
        return '/';
    return input;
}
export function applyPortalImpersonationCookies({ impersonateId, adminToken, context, }) {
    const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;
    deleteImpersonationCookie({ scope: 'global' }, context);
    // Ensure we don't end up with both host-only and domain cookies for the same name.
    // Having duplicates can lead to ambiguous cookie parsing on the server.
    deleteCookie(ADMIN_JWT_COOKIE_NAME, { path: '/' }, context);
    if (rootDomain) {
        deleteCookie(ADMIN_JWT_COOKIE_NAME, { domain: rootDomain, path: '/' }, context);
    }
    setImpersonationCookie(impersonateId, { scope: 'host-only' }, context);
    setCookie(ADMIN_JWT_COOKIE_NAME, adminToken, {
        secure: import.meta.env.VITE_APP_ENVIRONMENT === 'production',
        sameSite: 'lax',
        ...(rootDomain ? { domain: rootDomain } : {}),
        path: '/',
        maxAge: 60 * 60,
    }, context);
}
export function clearPortalImpersonationCookies({ context, impersonationScope = 'host-only', }) {
    const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;
    // Mirror the scopes used by applyPortalImpersonationCookies:
    // - X-Impersonate-Id is set host-only (overridable via impersonationScope)
    // - th_admin_jwt is always set on the root domain
    deleteImpersonationCookie({ scope: impersonationScope }, context);
    deleteCookie(ADMIN_JWT_COOKIE_NAME, { domain: rootDomain, path: '/' }, context);
}
//# sourceMappingURL=portalImpersonation.js.map